import type { Configuration } from '@repo/api-gw-sdk';
import { ProjectsApi } from '@repo/api-gw-sdk';

import type { HttpClient } from './httpClient';

const baseUrl = '/projects';

export const projects = (httpClient: HttpClient, config: Configuration) => {
  const projectsApi = new ProjectsApi(config);

  return {
    useList: () =>
      httpClient.execute(
        projectsApi.listProjects.bind(projectsApi),
        baseUrl,
        '',
        undefined,
        500
      ),
  };
};
